// Done-for-you: la configuración del cliente la edita solo el superadmin.
// El client_admin opera oportunidades, contactos, chats, estadísticas y equipo,
// y sigue editando el contenido del sitio (cms). Estas funciones las usan las
// rutas (redirigen) y el menú (oculta).

export const CONFIG_SETTINGS_TABS = ['notifications', 'chatbot', 'schemas'] as const;

/** Pestañas profundas que salieron de /settings y viven en la ficha del cliente. */
const SETTINGS_DEEP_TABS: Record<string, string> = {
  notifications: 'avisos',
  chatbot: 'chatbot',
  schemas: 'estructura',
  pipelines: 'embudos',
};

const PATH_DEEP_TABS: Record<string, string> = {
  '/chatbot': 'chatbot',
  '/schemas': 'estructura',
  '/pipelines': 'embudos',
};

export type DeepConfigRedirect =
  | { to: '/clientes' }
  | { to: '/clientes/$id'; params: { id: string }; search: { tab: string } };

/**
 * A dónde manda al superadmin un atajo viejo de configuración profunda.
 * Sin tenant elegido, cae en la lista de clientes.
 */
export function superadminDeepConfigTarget(
  spec: { tab?: string | null; path?: string | null },
  tenantId: string | null | undefined,
): DeepConfigRedirect | null {
  const tab =
    (spec.tab ? SETTINGS_DEEP_TABS[spec.tab] : undefined) ||
    (spec.path ? PATH_DEEP_TABS[spec.path] : undefined) ||
    null;
  if (!tab) return null;
  if (!tenantId) return { to: '/clientes' };
  return { to: '/clientes/$id', params: { id: tenantId }, search: { tab } };
}

const SELECTED_TENANT_KEY = 'focus_admin_selected_tenant';

export function readSelectedTenantId(): string | null {
  try {
    return localStorage.getItem(SELECTED_TENANT_KEY);
  } catch {
    return null;
  }
}

const CONFIG_PATHS = new Set([
  '/chatbot',
  '/schemas',
  '/configuracion/correo',
  '/configuracion/agentes',
]);

export function configRouteRedirect(
  role: string | null | undefined,
  pathname: string,
  tab?: string | null,
): { to: '/' | '/crm' | '/team' } | null {
  const path = (pathname.split('?')[0] || '/').replace(/\/+$/, '') || '/';
  // Equipo vive al final del menú del cliente. Mi perfil está en el avatar.
  if (path === '/settings' && tab === 'team') return { to: '/team' };
  if (role === 'superadmin') return null;
  // El editor de etapas es configuración. El tablero (operación) está en /crm.
  if (path === '/pipelines' || (path === '/settings' && tab === 'pipelines')) {
    return { to: '/crm' };
  }
  if (path === '/clientes' || path.startsWith('/clientes/')) return { to: '/' };
  if (CONFIG_PATHS.has(path)) return { to: '/' };
  if (path === '/settings' && tab && (CONFIG_SETTINGS_TABS as readonly string[]).includes(tab)) {
    return { to: '/' };
  }
  return null;
}

export function hideConfigFromClientMenu(role: string | null | undefined, to: string): boolean {
  if (role === 'superadmin') return false;
  return (
    to === '/chatbot' ||
    to === '/schemas' ||
    to === '/pipelines' ||
    to === '/configuracion/correo' ||
    to === '/configuracion/agentes'
  );
}
